<template>
  <div class="sem-conteudo" v-if="!content">
    <p>
      Não foi encontrado nenhuma informação. Por favor altere os seus filtros de busca!
    </p>
  </div>
</template>

<script>
  export default {
    name: 'NotFoundItems',
    props: {
      content: [Object, Array]
    }
  };
</script>

<style scoped lang="scss">

  .sem-conteudo {
    text-align: center;

    p {
      display: inline-block;
      padding: 20px;
      margin: 0;

      font-family: 'Lato', sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #bb3a31;
      text-align: center;

      background-color: #eeeeee;
      border-radius: 5px;
    }
  }

</style>

